/* Homepage hero crossfade, ported from Home.dc.html (2026-08-10 handoff).
   5 slides, 5500ms auto-advance, timer resets on manual nav. */
(function () {
  var root = document.querySelector('[data-mph-hero]');
  if (!root) return;

  var LABELS = ['WEDDINGS', 'THE FRONT ROW', 'LAKE SEASON', 'CAMPS', 'THE OFFSITE'];
  var slides = root.querySelectorAll('[data-mph-slide]');
  var dots = root.querySelectorAll('[data-mph-dot]');
  var label = root.querySelector('[data-mph-label]');
  var count = slides.length;
  var current = 0;
  var timer = null;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Slides 2 to 5 ship with data-src only (see mp-home.liquid). A slide is
     given its real src the moment it is about to show, and the one after it
     is fetched at the same time, so the 5.5s crossfade never lands on a blank. */
  function hydrate(i) {
    var img = slides[((i % count) + count) % count];
    if (!img || !img.hasAttribute('data-src')) return;
    img.srcset = img.getAttribute('data-srcset') || '';
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function show(i) {
    current = ((i % count) + count) % count;
    hydrate(current);
    hydrate(current + 1);
    slides.forEach(function (img, n) { img.classList.toggle('is-on', n === current); });
    dots.forEach(function (dot, n) { dot.classList.toggle('is-on', n === current); });
    if (label) label.textContent = LABELS[current] || '';
  }

  function arm() {
    if (reduceMotion) return;
    if (timer) clearInterval(timer);
    timer = setInterval(function () { show(current + 1); }, 5500);
  }

  function go(i) { show(i); arm(); }

  root.querySelector('[data-mph-prev]').addEventListener('click', function () { go(current - 1); });
  root.querySelector('[data-mph-next]').addEventListener('click', function () { go(current + 1); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-mph-dot'), 10)); });
  });

  arm();

  /* the second slide is fetched once the page has finished loading, well
     before the first advance at 5.5s */
  function warm() { setTimeout(function () { hydrate(1); }, 1200); }
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm, { once: true });
})();
